export default __webpack_public_path__ + "static/media/setting.509b05b0.svg";